import { UserProfileProductReview } from "@/custom-types/Reviews";

import ReviewCard from "../ReviewCard";

type Props = {
  review: UserProfileProductReview;
};

const ProductReviewCard = ({
  review: {
    created,
    isPrivate,
    product: { name },
    productSlug,
    text,
  },
}: Props) => (
  <ReviewCard
    text={text}
    title={name}
    itemUrl={`/products/details/${productSlug}`}
    createdDate={created}
    isPrivate={isPrivate}
  />
);

export default ProductReviewCard;
